export default function getConfig(
  appName: string,
  container: string,
  redirectUrl: string
): Auth0LockConstructorOptions {
  return {
    allowAutocomplete: true,
    allowForgotPassword: true,
    allowLogin: true,
    allowPasswordAutocomplete: true,
    allowShowPassword: true,
    allowSignUp: false,
    auth: {
      redirect: true,
      redirectUrl,
      responseType: 'token',
    },
    avatar: null,
    container,
    initialScreen: 'login',
    languageDictionary: {
      title: appName,
    },
    loginAfterSignUp: true,
    rememberLastLogin: false,

    theme: {
      labeledSubmitButton: true,
      // the following two styles are hard-coded to avoid a public
      // dependency requiredment on the theme-provider libarary as
      // auth-provider is a required dependency for our public libs
      logo: 'https://mcdn.bymason.com/mason_logo.png',
      primaryColor: '#625FFF',
    },
  };
}
